import "pickadate/lib/picker";
import "pickadate/lib/picker.date";

import "pickadate/lib/themes/default.css";
import "pickadate/lib/themes/default.date.css";

$(document).ready(function() {
  $("#startdate, #enddate").pickadate({
    format: "yyyy-mm-dd",
    formatSubmit: "yyyy-mm-dd",
    hiddenName: true,
    onStart: function() {
      const dates = location.search.substr(1).split("&");
      let startDate = "";
      let endDate = "";
      for (let date in dates) {
        if (dates[date].split("=")[0] == "startdate") {
          startDate = dates[date].split("=")[1];
        } else if (dates[date].split("=")[0] == "enddate") {
          endDate = dates[date].split("=")[1];
        }
      }
      const thisId = this.$node.attr("id");
      if (thisId == "startdate" && startDate !== "") {
        this.set("select", [
          startDate.split("-")[0],
          parseInt(startDate.split("-")[1]) - 1,
          startDate.split("-")[2]
        ]);
      }
      if (thisId == "enddate" && endDate !== "") {
        this.set("select", [
          endDate.split("-")[0],
          parseInt(endDate.split("-")[1]) - 1,
          endDate.split("-")[2]
        ]);
      }
    },
    onClose: function() {
      const currentLocation = location.href.split("?")[0];
      const startDate = $("#startdate").val();
      const endDate = $("#enddate").val();
      const search = $('input[name="search"]').val()
      let params = new URLSearchParams(window.location.search)
      if (startDate != params.get('startdate') || endDate != params.get('enddate')) {
        getEvents(startDate, endDate, getCategory(window.location.href), search)
      }
    }
  });

  $(".category-dropdown").on('click', '.dropdown-item', function(e) {
    e.preventDefault();
    let category = getCategory(this.href)
    let params = new URLSearchParams(window.location.search)
    getEvents(params.get('startdate'), params.get('enddate'), category, $('input[name="search"]').val())
    $('.category-dropdown .dropdown-item').removeClass('disabled')
    this.classList.add('disabled')
    this.closest('.dropdown').querySelector('a#dropdownMenuLink').textContent = this.textContent
    $('span.category-name').text(this.textContent)
  })

  $(".category_links a").on('click', e => {
    e.preventDefault();
    let category = getCategory(e.target.href)
    let params = new URLSearchParams(window.location.search)
    getEvents(params.get('startdate'), params.get('enddate'), category, $('input[name="search"]').val())
    $(".category_links .cluster__list__item").removeClass('cluster__list__item--active')
    $(e.target).addClass('cluster__list__item--active')
  })

  $('#search_form').on('submit', e => {
    e.preventDefault()
    e.stopPropagation()
    let params = new URLSearchParams(window.location.search)
    getEvents(params.get('startdate'),
              params.get('enddate'),
              getCategory(window.location.href),
              $('input[name="search"]').val())
  })
});

function getCategory(url) {
  let category = url.match(/\/events\/category\/([^/]+)/)
  return category && category[1]
}

function getEvents(startDate, endDate, category, search) {
  let baseUrl = category ? `/events/category/${category}/` : `/events/`
  let params = new URLSearchParams(window.location.search)
  startDate && params.set('startdate', startDate)
  endDate && params.set('enddate', endDate)
  search ? params.set('search', search) : params.delete('search')
  params.set('partial', 'True')
  let fullFetchUrl = `${baseUrl}?${params}`
  params.delete('partial')
  let fullHistoryUrl = `${baseUrl}?${params}`

  let eventsContainer = document.querySelector('.events-container')
  let parentNode = eventsContainer.parentNode
  eventsContainer.innerHTML = ''
  document.querySelectorAll('.events-pagination').forEach(el => el.remove())
  $('.spinner').remove()
  let spinner = document.createElement('div')
  spinner.classList.add('spinner')
  parentNode.append(spinner)
  let bottomBody = parentNode.querySelector('.bottom-body')

  fetch(fullFetchUrl)
    .then(res => res.text())
    .then(html => {
      spinner.remove()
      eventsContainer.remove()
      let newNode = document.createElement('div')
      newNode.innerHTML = html
      Array.from(newNode.children).forEach(child => parentNode.insertBefore(child, bottomBody))
      handleLazyImages()
      window.history.pushState(null, '', fullHistoryUrl)
    })
}
